import { REPORT_THANKS } from "./useReporting.js";

/** The live region exists before the text does, so a screen reader hears the thanks arrive. */
export function ReportNotice({ thanks }: { thanks: boolean }) {
  return (
    <p className={thanks ? "notice report__thanks" : "report__thanks"} role="status">
      {thanks ? REPORT_THANKS : ""}
    </p>
  );
}
